<template>
    <section class="primaryInfo">
        <a name="home" style=" position: relative;top: -420px;display: block;height: 0;overflow: hidden;"></a>
        <section class="information">
            <section class="innerBox">
                <div class="leftMenu">
                    <li @click="gotoHandle(leftItem.anchorId)"
                        :class="['menu-item',isActive === leftItem.anchorId?'menu-item--active':'']"
                        v-for="(leftItem,idx) in leftMenus" :key="idx">
                        {{leftItem.title}}
                    </li>
                </div>
                <div class="info">

                    <h1>PayBy Terms of Use</h1>
                    <h3>Last Update: March 18 2020</h3>
                    <p>
                        <strong>
                            Please read these Terms of Use carefully
                        </strong>
                    </p>
                    <br>
                    <p>
                        These terms of use (the "<strong>Terms</strong>") form a binding contract between you and ToTok Technology Ltd and PayBy Technology Projects LLC (together, 
                        "<strong>PayBy</strong>","<strong>we</strong>","<strong>us</strong>"or "<strong>our</strong>"), and governs your ("<strong>your</strong>" or "<strong>User</strong>") use of all PayBy Services. 
                        By accessing, via ToTok, and using the PayBy Services or any of its features, 
                        you are agreeing to comply with all of the terms and conditions contained in these Terms,
                         which shall be final and legally binding in all matters relating to the PayBy Services.
                          Unless expressly defined herein, any capitlised words or phrases shall have the meaning given in the Definitions section at the end of these Terms.
                    </p>
                    <p>PayBy Services are only available to users of the messaging application ToTok provided by ToTok, and you hereby acknowledge that you are a user of ToTok and have a valid account with ToTok. Your use of ToTok will be governed by the ToTok Terms of Use accessible at <a href="/terms">ToTok Terms of Use</a>. Any references to the "<strong>App</strong>" within these Terms will be read as ToTok and/or the PayBy Services area of ToTok.  The following provisions from the ToTok Terms of Use shall apply to the PayBy Services: clauses <a href="/terms">1 (Contact); 2 (Language); 6 (Acceptable Use); 8 (Licences and Intellectual Property); 9 (Updates); 10 (Support); 11 (Disclaimer); 12 (Our Liability); 13 (Your Liability); 14 (Termination); 15 (General); and 16 (Governing Law)</a>.  Any reference in any such clause to "we", "us", "our" or "ToTok" shall be construed as referring to "PayBy" as defined in these Terms, and any reference to "Services" shall be construed as referring to the "PayBy Services". 
                    </p>
                    <p>You will be notified of any changes to these Terms via email, the App, or through another medium of using the PayBy Services. Your continued use of the PayBy Services will be deemed acceptance of the updated Terms. If you do not accept the updated Terms, you are no longer permitted to use the PayBy Services and should cease using the PayBy Services immediately.</a>
                    </p>
                    <h2>
                        1. PayBy And Eligibility
                    </h2>
                    <p>
                        <strong>1.1 PayBy’s Services.</strong> With respect to the PayBy Services, PayBy provides Users with the ability to make and secure peer-to-peer payments to and from other users by creating, hosting, maintaining and providing our PayBy Services to you. Subject to this, the PayBy Services allow you to:
                    </p>
                    
                    <ul>
                        <li>send payments to anyone with a PayBy Account, and, where available, to receive payments;
                        </li>
                        <li>use the QR Code feature of your PayBy Account to purchase goods from Merchants;
                        </li>
                        <li>pay or request another User to pay a bill for you; and
                        </li>
                        <li>to add value to your PayBy Account.
                        </li>
                    </ul>
                    <p>
                            A payment may be sent from either your PayBy Account balance or from your credit card account(s) which have been linked to your PayBy Account.
                        </p>
                        <p>We do not have any control over, and are not responsible or liable for, the products or services that you purchase using PayBy Services. We cannot ensure that the other party you are dealing with will actually complete the transaction.</li>
                        <p>PayBy is not a common carrier or public utility.
                        </p>
                    <p><strong>1.2 Eligibility. </strong>By using the PayBy Services, you acknowledge that you: (i) are at least 18 years old or higher based on the age of majority in the user’s jurisdiction, notwithstanding the age requirement to use ToTok; and (ii) a resident of The United Arab Emirates. Any User under the age of majority in its jurisdiction must have parental/guardian permission prior to using PayBy Services. We reserve the right to ask for proof of age and evidence to verify your identity at any time.</p>
                    <p>You acknowledge that PayBy allows the execution of transactions in The United Arab Emirates only and that Value Added Tax (VAT) may be chargeable on sales and purchases of products and services you make using PayBy Services.
                    </p>
                    <p><strong>1.3 Information.</strong> In order to open and maintain an Account, you must provide us with correct and up to date Information.  We will also use certain of the Information you have provided us through your use of the App. For more details on how we collect, use and otherwise process your Information, please see <a href="/totokpayprivacy">PayBy Privacy Statement</a>.</p>
                    <p><strong>Identity Verification.</strong> In addition to these inquiries we are required to make by law, you acknowledge that PayBy may, directly or through third parties, make any inquiries we consider necessary to validate your identity. This may include asking you for further information or documentation, requiring you to provide a taxpayer or national identification number, requiring you to take steps to confirm ownership of your phone number (including mobile phone number), email address or financial instruments, ordering a credit report or verifying your Information against third party databases or through other sources. You agree to co-operate fully with PayBy with respect to verifying your identity.</p>
                    <p><strong>Updates to Information.</strong> If your debit card or credit card number or expiration date changes, we may update it without any action on your part and we may acquire such updated information from a third party including our financial services partner, the card networks, and your bank or card issuer. If you do not want us to update your card information, you may contact your issuer to request this or remove your Payment Method from your PayBy Account. If we update your Payment Method, we will keep any preference setting attached to such Payment Method.</p>
                    <p><strong>1.4 Beneficial Owner. </strong>You must be the beneficial owner of the Account, and conduct business only on behalf of yourself.
</p>
<h2>2. Sending Payments</h2>
<p><strong>2.1 Account and Sending Limits.</strong> We may, at our discretion, impose limits on the amount of funds in your Account and the value of any payments you can send and receive through the PayBy Services. You can view your sending limit, if any, by logging into your Account. If you have a Verified Account, we may increase your sending limits.
</p>
<p><strong>2.2 Default Payment Methods.</strong> When you make a payment, if you have not selected a Preferred Payment Method, PayBy will fund your transaction in this order (subject to availability based on your Payment Methods and country/region of registration):
</p>
                    <ul>
                        <li>
                            Balance
                        </li>
                        <li>
                            Instant Transfer from your bank account
                        </li>
                        <li>Debit card
                        </li>
                        <li>
                            Credit card
                        </li>
                        
                    </ul>
                    <p>In certain countries, you may be able nominate a Preferred Payment Method in your Account Profile or select a Preferred Payment Method each time you make a payment, except for a Preapproved Payment.
</p>
<p>PayBy may limit the Payment Methods available for a transaction. Some Payment Methods may not be available in certain circumstances, including:
</p>
<ul>
    <li>American Express may not be available as a Payment Method for certain merchants, such as branded airlines and certain travel merchants;</li>
    <li>Some credit cards may not be available as a Payment Method for certain merchants; and</li>
    <li>Credit cards cannot be used to send Personal Payments or to Top Up your PayBy balance.</li>
</ul>
<p>If the Preferred Payment Method fails (for example, a credit card or debit card expires) and your PayBy account cannot complete a transaction, it may be used again to try to complete the transaction. If the Preferred Payment Method in your PayBy account cannot complete a transaction after repeated attempts, each of the other payment methods available in your PayBy account may be used to try to complete the transaction.
</p>
<p><strong>2.3 Cards as Payment Methods.</strong> By adding a debit card or credit card as a Payment Method, you are providing PayBy with continuous authority to automatically charge that card to obtain the relevant funds when the card is used as a Payment Method pursuant to these Terms (including Add Money to your PayBy Account). You can stop the continuous authority in respect of any card by removing that card as a Payment Method in your Account Profile.
</p>
<p><strong>2.4 Preferred Payment Method.</strong> You may select a Preferred Payment Method each time you make a payment.
</p>
<p><strong>2.5 Refused and Refunded Payments.</strong> When you send a payment, the recipient is not required to accept it. Any unclaimed, refunded or denied payment will be returned to your balance or to your original Payment Method. We will return any unclaimed payment to you within 45 Days of the date you initiated the payment.
</p>
<p>When you send a payment online using PayBy and the transaction is ultimately refunded, the money will be refunded to the original payment method you used for the transaction if you used a debit card, credit card or PayBy balance. If you used a bank account as the payment method for the transaction, we will refund the money to your bank account, or to your PayBy balance if we cannot refund it to your bank account.
</p>
<p><strong>2.6 Merchant Processing Delay.</strong> When you send a payment to certain Merchants, you are providing an authorization to the Merchant to process your payment and complete the transaction. The payment will be held as pending until the Merchant processes your payment. Some Merchants may delay processing your payment. In such an instance, your authorization will remain valid for up to 30 Days. If your payment requires a currency conversion, the exchange rate will be determined at the time the Merchant processes your payment and completes the transaction.
</p>
<h2>3. Account Balances</h2>
<p>
If you hold a balance on your Account, PayBy will hold your funds in pooled accounts held with a licensed bank which are separate from its corporate funds, and it will not use your funds for its operating expenses or for any other corporate purposes. PayBy will not voluntarily make your funds available to its creditors in the event of bankruptcy. You will not receive interest or other earnings on the amounts in your balance. PayBy may receive interest on amounts that PayBy holds on your behalf. You agree to assign your rights to PayBy for any interest derived from your funds.
</p>
<h2>4.Closing Your Account
</h2>
<p><strong>4.1 How to Close Your Account.</strong> You may close your Account at any time by following the instructions in your Account Profile. Upon Account closure, we will cancel any pending transactions and you will forfeit any balances associated with Redemption Codes, unless otherwise legally prohibited. You must withdraw your balance prior to closing your Account.
</p>
<p><strong>4.2 Limitations on Closing Your Account.</strong> You may not evade an investigation by closing your Account. If you close your Account while we are conducting an investigation, we may hold your funds to protect PayBy, Affiliates or a third party against the risk of Reversals, Chargebacks, Claims, fees, fines, penalties and other liability. You will remain liable for all obligations related to your Account even after the Account is closed.
</p>
<h2>5. Errors and Unauthorized Transactions
</h2>
<p><strong>5.1 Protection for Unauthorized Transactions and Errors.</strong> When an Unauthorized Transaction or an Error occurs in your Account, PayBy will cover you for the full amount of every eligible Unauthorized Transaction or Error so long as you follow the procedures discussed below.
</p>
<p>An "Unauthorized Transaction" occurs when a payment is sent from your Account that you did not authorize and that did not benefit you. For example, if someone steals your password, uses the password to access your Account, and sends a payment from your Account, an Unauthorized Transaction has occurred. If you give someone access to your Account (by giving them your login information) and they conduct transactions without your knowledge or permission, you are responsible for any resulting use.
</p>
<p><strong>5.2 Notification Requirements.</strong>
</p>
<p>You should immediately notify PayBy if you believe:
</p>
<ul>
    <li>there has been an Unauthorized Transaction or unauthorized access to your Account;</li>
    <li>there is an Error in your Account history statement or in your transaction confirmation sent to you by email;</li>
    <li>your password has been compromised;</li>
    <li>your PayBy Mobile-activated phone has been lost, stolen or deactivated; or</li>
    <li>you need more information about a transaction listed on the statement or transaction confirmation.</li>
</ul>
<p>To be eligible for protection for Unauthorized Transactions, you must notify us within 60 Days after any Unauthorized Transaction first appears in your Account history statement. We will extend the 60 Day time period if a good and demonstrable reason, such as a hospital stay, kept you from notifying us within 60 Days.
</p>
<p>You should regularly log into your Account and review your Account history statement to ensure that there has not been an Unauthorized Transaction or Error. You should also review these transaction confirmations to ensure that each transaction was authorized and is accurate.
</p>
<p>For Unauthorized Transactions or Errors in your Account, notify us as follows:
</p>
<ul>
    <li>Email to PayBy: <a mailto="privacy@totok.ai">privacy@totok.ai</a></li>
</ul>
<p>When you notify us, provide us with all of the following information:
</p>
<ul>
    <li>Your name and mobile phone number registered to your Account;
</li>
<li>A description of any suspected Unauthorized Transaction or Error and an explanation as to why you believe it is incorrect or why you need more information to identify the transaction; and</li>
<li>The amount of any suspected Unauthorized Transaction or Error.</li>
</ul>
<p>If you notify us orally, we may require that you send us your complaint or question in writing within 10 Business Days. During the course of our investigation, we may request additional information from you.
</p>
<p><strong>5.3 PayBy Actions after Receipt of Your Notification.</strong> Once you notify us of any suspected Unauthorized Transaction or Error, or we otherwise learn of one, we will do the following:
</p>
<ul>
    <li>We will conduct an investigation to determine whether there has been an Unauthorized Transaction or Error that is eligible for protection.</li>
<li>We will complete our investigation within as soon as reasonably practicable following receipt of your notification of the suspected Unauthorized Transactions or Error. If your Account is new (the first transaction from your Account was less than 30 Business Days from the date you notify us), we may take longer to complete this investigation. We may need additional time to complete this investigaton  for new Accounts, or if your transaction was at a point of sale where you were physically present.
</li>
<li>We will inform you of our decision within 5 Business Days after completing our investigation.</li>
</ul>
<p>If we determine that there was an Unauthorized Transaction or Error, we will promptly credit the full amount into your Account within 2 Business Day of our determination. Or, if you have already received a provisional credit, you will be allowed to retain those amounts.</p>
                    <p>If we decide that there was not an Unauthorized Transaction or Error, we will include an explanation of our decision in our email to you. If you received a provisional credit, we will remove it from your Account and notify you of the date and amount of the debit. You may request copies of the documents that we used in our investigation.</p>
                    <p><strong>5.4 PayBy Errors.</strong> We will rectify any Error that we discover. If the Error results in your receipt of less than the correct amount to which you are entitled, PayBy will credit your Account for the difference. If the Error results in your receipt of more than the correct amount to which you are entitled, PayBy will debit the extra funds from your Account.
</p>
                   <p><strong>5.5 Your Errors.</strong> If you erroneously send a payment to the wrong party, or send a payment for the wrong amount (based on a typographical error, for example), your only recourse will be to contact the party to whom you sent the payment and ask them to refund the payment. PayBy will not reimburse you or reverse a payment that you have made in error.
</p>
                    <h2>6. Restricted Activities
</h2>
<p><strong>6.1 Restricted Activities.</strong> In connection with your use of your Account, the PayBy Services, or in the course of your interactions with PayBy, other users, or third parties, you will not:
</p>
<ul>
    <li>Breach these Terms, the ToTok Terms of Use or any other terms or policies that you have agreed to with PayBy;
</li>
<li>Violate any law, statute, ordinance, or regulation to which you are subject;
</li>
<li>Sell counterfeit goods or services;
</li>
<li>Provide false, inaccurate or misleading Information;
</li>
<li>Engage in potentially fraudulent or suspicious activity and/or transactions;
</li>
<li>Refuse to cooperate in an investigation or provide confirmation of your identity or any Information you provide to us;
</li>
<li>Receive or attempt to receive funds from both PayBy, bank or card issuer for the same transaction during the course of a Dispute;
</li>
<li>Control an Account that is linked to another Account that has engaged in any of these Restricted Activities;
</li>
<li>Use the PayBy Services in a manner that results in or may result in complaints, Disputes, Claims, Reversals, Chargebacks, fees, fines, penalties and other liability to PayBy, other users, third parties or you;
</li>
<li>Have a credit score from a credit reporting agency that indicates a high level of risk associated with your use of the PayBy Services;
</li>
<li>Use your Account or the PayBy Services in a manner that PayBy, Visa, Mastercard, American Express, Discover or any other electronic funds transfer network reasonably believes to be an abuse of the card system or a violation of card association or network rules;
</li>
<li>Allow your Account to have a negative balance;
</li>
<li>Use a credit card with your Account to provide yourself a cash advance (or help others to do so);
</li>
<li>Disclose or distribute another User’s Information to a third party, or use the Information for marketing purposes unless you receive the User’s express consent to do so.
</li>
</ul>
<h2>7. Your Liability: Actions We May Take
</h2>
<p><strong>7.1 Your Liability.</strong>
</p>
<p><strong>General.</strong> You are responsible for all Reversals, Chargebacks, Claims, fees, fines, penalties and other liabilities and damages suffered by PayBy, a User, or a third party caused by or arising out of your breach of these Terms, and/or your use of the PayBy Services, and/or any misrepresentation made by you You agree to reimburse PayBy, a User, or a third party for any and all such liabilities.
</p>
<p><strong>Liability for instructions given by you on your Account.</strong> Any instructions given by you on your Account (whether verbal or in writing) once you have been authenticated will be relied on by PayBy. PayBy will not be liable for any loss or damage you or anyone else suffers where PayBy acts on those instructions in good faith, unless it was proved that PayBy was negligent.
</p>
<p><strong>7.2 Reimbursement for Your Liability.</strong> In the event that you are liable for any amounts owed to PayBy, PayBy may immediately remove such amounts from your balance. If you do not have a balance that is sufficient to cover your liability, your remaining balance (if any) will be removed, your Account will have negative balance up to the amount of your liability, and you will be required to immediately Add Money to your PayBy balance or reimburse PayBy through an alternative method. If you do not do so, PayBy may engage in collection efforts to recover such amounts from you.
</p>
<p><strong>7.3 Actions by PayBy: Restricted Activities.</strong> If PayBy, in its sole discretion, believes that you may have engaged in any Restricted Activities, we may take various actions to protect PayBy, Affiliates other Users, other third parties or you from Reversals, Chargebacks, Claims, fees, fines, penalties and any other liability. The actions we may take include but are not limited to the following:
</p>
<ul>
    <li>We may close, suspend, or limit your access to your Account or the PayBy Services;
</li>
<li>We may hold, apply or transfer the funds in your Account as required by judgments and orders which affect you or your Account, including judgments and orders issued by courts in anywhere and directed to PayBy or its Affiliates;
</li>
<li>We may refuse to provide the PayBy Services to you now and in the future; and
</li>
<li>We may hold your funds for a period of time reasonably needed to protect against the risk of liability to PayBy or a third party, or if we believe that you may be engaging in potentially fraudulent or suspicious activity and/or transactions.</li>
</ul>
<p><strong>7.4 Actions by PayBy: Holds.</strong></p>
<p><strong>a. Risk-Based Holds.</strong> PayBy, in its sole discretion, may place a hold on any or all of the payments you receive when PayBy believes there may be a high level of risk associated with you, your Account, or any or all of your transactions. PayBy’s determination may be based on different factors and PayBy may rely on information it receives from third parties. If PayBy places a hold on a payment, the funds will appear as pending balance or withheld and the payment status will indicate the hold. If PayBy places a hold on any or all of the payments you receive, PayBy will provide you with notice of our actions. PayBy will release the hold on any payment after 30 Days from the date the payment was received into your Account unless PayBy has a reason to continue to hold the payment such as (a) the receipt of a Dispute, Claim, Chargeback, or Reversal, (b) PayBy believes that you have violated the terms of these Terms or any other Policy and that such a violation results in the need to continue holding the funds, or (c) PayBy believes that you may be engaging in potentially fraudulent or suspicious activity and/or transactions. In such an event, PayBy may continue holding the payment in your Account until the matter is resolved pursuant to these Terms. PayBy, in its sole discretion, may release the hold earlier under certain circumstances, for example when you upload tracking information of the item you shipped.
</p>
<p><strong>b. Disputed Transaction Holds.</strong> If a User files a Dispute, Claim, Chargeback or Reversal on a payment you received, PayBy may place a temporary hold on the funds in your Account to cover the amount of the liability. If you win the dispute, PayBy will lift the temporary hold. If you lose the dispute, PayBy will remove the funds from your Account.
</p>
<p><strong>7.5 Actions by PayBy: Reserves.</strong> PayBy, in its sole discretion, may place a Reserve on funds held in your Business Account when PayBy believes there may be a high level of risk associated with your Account or your use of any of the products and/or services offered by PayBy and/or its Affiliates. If PayBy places a Reserve in your Account, transactions will be shown as "pending" in your Account balance, and you will not have access to funds in a "pending" status until they are cleared. If your Account is subject to a Reserve, PayBy will provide you with notice specifying the terms of the Reserve. The terms may require that a certain percentage of the amounts received into your Account are held for a certain period of time, or that a certain amount of money is held in Reserve, or anything else that PayBy determines is necessary to protect against the risk associated with your Account. PayBy may change the terms of the Reserve at any time by providing you with notice of the new terms.
</p>
<p><strong>7.6 Actions by PayBy: Account Closure, Termination of Service, Limited Account Access; Confidential Criteria.</strong> PayBy, in its sole discretion, reserves the right to terminate these Terms and/or access to the PayBy Services for any reason and at any time upon written notice and payment to you of any unrestricted funds held in your balance. If we limit access to your Account, including through a Reserve or hold, we will provide you with notice of our actions, and the opportunity to request restoration of access if, in our sole discretion, we deem it appropriate. Further, you acknowledge that PayBy’s decision to take certain actions, including limiting access to your Account, placing holds or imposing Reserves, may be based on confidential criteria that is essential to our management of risk, the security of Users’ Accounts and the PayBy system. You agree that PayBy is under no obligation to disclose the details of its risk management or its security procedures to you.
</p>
<h2>8. General Terms
</h2>
<p><strong>8.1 Services Limitation.</strong> PayBy is not a bank and the PayBy Services are payment processing services rather than banking services. PayBy is not acting as a trustee, fiduciary or escrow with respect to your funds, but is acting only as an agent to you and custodian to your funds. PayBy does not have control of, nor liability for, the products or services that are paid for with the PayBy Services. We do not guarantee the identity of any User or ensure that a buyer or a Seller will complete a transaction.
</p>
<p><strong>8.2 Third party websites.</strong> Where the App contains links to other sites and resources provided by third parties, including social media sites, these links are provided for your information only. Such links should not be interpreted as approval by us of those linked websites or information you may obtain from them.
</p>
<p><strong>8.3 Password Security.</strong> You are responsible for maintaining adequate security and control of any and all IDs, passwords, personal identification numbers (PINs), or any other codes that you use to access the PayBy Services.
</p>
<p><strong>8.4 Taxes.</strong> It is your responsibility to determine what, if any, taxes apply to the payments you make or receive, and it is your responsibility to collect, report and remit the correct tax to the appropriate tax authority. PayBy is not responsible for determining whether taxes apply to your transaction, or for collecting, reporting or remitting any taxes arising from any transaction. Please be advised that you may be subject to withholding taxes or other tax liabilities with respect to importing services from a foreign entity. In addition, you may be subject to VAT, sales tax, income tax, or other tax liabilities as a seller of goods or services. It is your responsibility to check with your local tax advisor to determine which taxes apply to you, and it is your responsibility to pay such taxes to the appropriate tax authority. 
</p>
<p><strong>8.5 Complete Agreement and Survival.</strong> These Terms and the ToTok Terms of Use together set forth the entire understanding between you and PayBy with respect to the PayBy Services. If any provision of these Terms is held to be invalid or unenforceable, such provision shall be struck and the remaining provisions shall be enforced.
</p>
<p><strong>8.6 Assumption of Rights.</strong> If PayBy pays out a Claim, Reversal or Chargeback that you file against a recipient of your payment, you agree that PayBy assumes your rights against the recipient and third parties related to the payment, and may pursue those rights directly or on your behalf, in PayBy’s discretion.
</p>
<h2>9. Definitions
</h2> 
<ul>
    <li>"<strong>Account Profile</strong>" means the location on our website/APP where you can, after logging in, view and manage your profile, including your personal information, Payment Method details, Preapproved Payments authorizations, your selling tools, and your Account settings including your notification preferences and API Access permissions.
</li>
<li>"<strong>Account</strong>" or "<strong>PayBy Account</strong>" means your personal account with PayBy.
</li>
<li>"<strong>Add Money</strong>" or "<strong>Top Up</strong>" means your ability to transfer money from your bank account to your PayBy Account.
</li>
<li>"<strong>Affiliate</strong>" means a company that is a direct or indirect subsidiary of PayBy, or otherwise related to PayBy through common ownership or control.
</li>
<li>"<strong>Business Days</strong>" means Sunday through Thursday, excluding the official national holidays recognized in the United Arab Emirates.
</li>
<li>"<strong>Chargeback</strong>" means a request that a buyer files directly with his or her debit or credit card company or debit or credit card issuing bank to invalidate a payment.
</li>
<li>"<strong>Claim</strong>" means a challenge to a payment that a User files directly with PayBy pursuant to these Terms.
</li>
<li>"<strong>Days</strong>" means calendar days.
</li>
<li>"<strong>Default Payment Methods</strong>" means the order in which PayBy uses your Payment Methods to fund a transaction if you do not select a Preferred Payment Method.
</li>
<li>"<strong>Dispute</strong>" means a dispute filed by a User directly with PayBy pursuant to these Terms.
</li>
<li>"<strong>Error</strong>" means a processing error made by PayBy or its suppliers in which your Account is mistakenly debited or credited.
</li>
<li>"<strong>Information</strong>" means any Account information that you provide to us or that we receive from your use of PayBy or ToTok, including but not limited to personal information, financial information, or other information related to you.</li>
<li>"<strong>Instant Transfer</strong>" means a payment funded using the sender’s bank account in which PayBy credits the recipient instantly.</li>
<li>"<strong>Merchant</strong>" and "<strong>Seller</strong>" are used interchangeably and mean a merchant who the User can purchase goods and/or services from using the PayBy Services.</li>
<li>"<strong>Payment Method</strong>" means the payment method used to fund a transaction. The following payment methods may be used to fund a transaction (subject to availability): balance, Instant Transfer, credit card, debit card, and Redemption Codes.</li>
<li>"<strong>Personal Payment</strong>" means a payment to a friend or a family member such as your share of the rent or a dinner bill. Personal Payments may not be used for sending gifts. Personal Payments are not available in most countries.</li>
<li>"<strong>Preferred Payment Method</strong>" means a Payment Method that you select to fund a payment instead of using the Default Payment Methods.</li>
<li>"<strong>Redemption Code</strong>" means the sequence of letters, numbers, and/or symbols placed on gift certificates, promotional coupons or other promotional offers and used to obtain a benefit.</li>
<li>"<strong>Reserve</strong>" means a percentage of the funds received into your Account that we hold in order to protect against the risk of Reversals, Chargebacks, Claims or any other liability related to your Account and/or use of the PayBy Services.</li>
<li>"<strong>Restricted Activities</strong>" means those activities described in Section 6 of these Terms.</li>
<li>"<strong>Reversal</strong>" means PayBy reverses a payment you received because (a) it is invalidated by the sender’s bank, (b) it was sent to you in Error by PayBy, Affiliates, or any direct or indirect PayBy subsidiary, (c) the sender of the payment did not have authorization to send the payment (for example: the sender used a stolen credit card), (d) you received the payment for activities that violated these Terms, the Policy, or (e) PayBy decided a Claim against you.</li>
<li>"<strong>PayBy Services</strong>" means all our products and services and any other features, technologies and/or functionalities offered by us via the App solely related to the payment services and as further detailed in Section 1.1 .</li>
<li>"<strong>Unauthorized Transaction</strong>" means as defined in Section 5.1 of these Terms.</li>
<li>"<strong>User</strong>" means any person or entity using the PayBy Services including you.</li>
<li>"<strong>Verified Account</strong>" means an Account status that reflects that PayBy has verified that an Account holder has legal control of one or more of his or her Payment Methods. A Verified Account status does not constitute an endorsement of a User or a guarantee of a User’s business practices.</li>

</ul>

                </div>
                <div class="cp">All rights reserved, 2022 PayBy Technology Projects LLC</div>
            </section>
        </section>
    </section>
</template>

<script>

    export default {
        metaInfo() {
            return {
                title: 'Terms of Use - ToTok Messenger',
                meta: [
                    {property: 'og:title', content: 'Terms of Use - ToTok Messenger'},
                    {property:  'og:description', content: 'ToTok provide you service with serious procedures and commitment'},
                    {property: 'og:url', content: 'https://totok.ai/terms'},
                    {property: 'og:type', content: 'website'},
                    {property: 'og:image', content: 'https://static.totok.ai/pic/preview/free_unblocked_call.png'},
                    {property: 'og:site_name', content: 'ToTok'}
                ]
            }
        },
        components: {},
        data() {
            return {
                archivedVersionLabel:"(archived versions)",
                showinfo: false,
                isActive: 'totokpayterms',
                leftMenus: [
                    {
                        title: 'Terms of Use',
                        anchorId: "totokpayterms"
                    },
                    {
                        title: 'Privacy Policy',
                        anchorId: "totokpayprivacy"
                    }

                ]
            };
        },
        computed: {
            info() {
                return []
            }
        },
        methods: {
            gotoHandle(palice) {

                this.isActive = palice
                        this.$router.push(palice)
            }
        }
    }
</script>
<style scoped lang="stylus">
    @media only screen and (max-width: 700px) {
        .primaryInfo {
            padding: 0.8rem;
            background: #fafafa;
            height: 82vh;

            .leftMenu {
                display none
            }

            div {
                margin-left: 20px;
                margin-right: 20px;
            }

            .info {

                
                h1 {
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-size: 28px;
                    font-weight: 400;
                    color: #222222;
                    -webkit-font-smoothing: antialiased;
                    padding-bottom: 20px;
                    padding-top: 40px;
                    margin: 0px;
                }

                h2 {
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-size: 24px;
                    font-weight: 400;
                    color: #4377f2;
                    -webkit-font-smoothing: antialiased;
                    padding-bottom: 18px;
                    padding-top: 28px;
                    margin: 0px;
                }

                h3 {
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-size: 16px;
                    font-weight: 400;
                    color: #808080;
                    padding-bottom: 20px;
                    margin: 0;
                }

                h6 {
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-style: italic;
                    font-size: 16px;
                    font-weight: bold;
                    margin-bottom: 12px;
                    color: #555555;
                    text-rendering: optimizeLegibility;
                    line-height: 26px;
                }

                p {
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-size: 16px;
                    font-weight: normal;
                    margin-bottom: 12px;
                    color: #555555;
                    text-rendering: optimizeLegibility;
                    line-height: 26px;
                }

                ul {
                    list-style: disc;
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-size: 16px;
                    font-weight: normal;
                    margin-top: 0;
                    margin-bottom: 10px;
                    margin-left: 24px;
                    color: #555555;
                    text-rendering: optimizeLegibility;
                    line-height: 26px;
                }

                li {
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-size: 16px;
                    font-weight: normal;
                    margin-top: 0px;
                    margin-bottom: 10px;
                    color: #555555;
                    text-rendering: optimizeLegibility;
                    line-height: 26px;
                    margin-left: 20px;
                }

                a {
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-size: 16px;
                    font-weight: normal;
                    margin-bottom: 12px;
                    color: #4377f2;
                    text-rendering: optimizeLegibility;
                    line-height: 26px;
                }
            }
        }

        .cp {
            height: 3.5rem;
            font-size: 13px;
            color: #808080;
            line-height: 1.5rem;
            text-align: left;
        }
    }

    @media only screen and (min-width: 701px) {
        .primaryInfo {
            padding-top: 102px;
            width: 100vw;
            background: #fafafa;

            .information {
                margin: 0 auto;
                width: 1024px;

                .innerBox {
                    position relative;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    align-items: center;
                    height: 83vh;
                    overflow: auto;

                    .leftMenu {
                        position: absolute;
                        left: 0px;
                        top: 39px;
                        display flex;
                        flex-direction column;
                        justify-content center;
                        align-items: center;
                        list-style none;

                        .menu-item {
                            color: #979797;
                            margin-top: 30px;
                            cursor pointer;
                            text-decoration none;
                            font-size: 15px;
                        }

                        .menu-item:nth-child(1) {
                            margin-top: 0px;
                        }

                        .menu-item--active {
                            color: #000;
                            border-bottom: 2px solid #4377f2;
                        }

                    }
                }
            }

            .info {
                width: 610px;
                margin: 20px 0;

                h1 {
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-size: 28px;
                    font-weight: 400;
                    color: #222222;
                    -webkit-font-smoothing: antialiased;
                    padding-bottom: 20px;
                    padding-top: 20px;
                    margin: 0px;
                }

                h2 {
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-size: 24px;
                    font-weight: 400;
                    color: #4377f2;
                    -webkit-font-smoothing: antialiased;
                    padding-bottom: 18px;
                    padding-top: 28px;
                    margin: 0px;
                }

                h3 {
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-size: 16px;
                    font-weight: 400;
                    color: #808080;
                    padding-bottom: 20px;
                    margin: 0;
                }

                h6 {
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-style: italic;
                    font-size: 16px;
                    font-weight: bold;
                    margin-bottom: 12px;
                    color: #555555;
                    text-rendering: optimizeLegibility;
                    line-height: 26px;
                }

                p {
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-size: 16px;
                    font-weight: normal;
                    margin-bottom: 12px;
                    color: #555555;
                    text-rendering: optimizeLegibility;
                    line-height: 26px;
                }

                ul {
                    list-style: disc;
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-size: 16px;
                    font-weight: normal;
                    margin-top: 0;
                    margin-bottom: 10px;
                    margin-left: 24px;
                    color: #555555;
                    text-rendering: optimizeLegibility;
                    line-height: 26px;
                }

                li {
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-size: 16px;
                    font-weight: normal;
                    margin-top: 0px;
                    margin-bottom: 10px;
                    color: #555555;
                    text-rendering: optimizeLegibility;
                    line-height: 26px;
                    margin-left: 20px;
                }

                a {
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-size: 16px;
                    font-weight: normal;
                    margin-bottom: 12px;
                    color: #4377f2;
                    text-rendering: optimizeLegibility;
                    line-height: 26px;
                }
            }
        }

        .cp {
            height: 70px;
            font-size: 13px;
            color: #808080;
            line-height: 70px;
            text-align: center;
        }
    }
</style>